import { LoanItemStatus, LoanItemStatusIconType } from '../../shared/models';
// Note: Cannot use barrel import due to circular dependency
import { FeatureName } from '../../core/state/feature-flag.repository';

export enum LoanStatusCardType {
  LoanDetails = 'Loan Details',
  TRID = 'TRID',
  Credit = 'Credit',
  Pricing = 'Pricing',
  Fees = 'Fees',
  AUS = 'AUS',
  Docs = 'Docs',
  Form4506C = '4506-C',
  Disclosures = 'Disclosures',
  LoanSummary = 'Loan Summary',
  AUSHistory = 'AUS History',
}

export interface ILoanStatusCard {
  cardType: LoanStatusCardType;
  displayOrder?: number;
  title?: string;
  descriptionHtml?: string;
  icon?: LoanItemStatusIconType;
  status?: LoanItemStatus;
  selected?: boolean;
  isHidden?: boolean;
  navigation?: string;
  exactMatch?: boolean;
  action?: () => void;
  hasPopover?: boolean;
  featureFlag?: FeatureName;
}

export const LoanStatusCardConfig: ILoanStatusCard[] = [
  {
    cardType: LoanStatusCardType.LoanSummary,
    title: LoanStatusCardType.LoanSummary,
    displayOrder: 1,
    icon: LoanItemStatusIconType.EmptyCircle,
    status: LoanItemStatus.NotComplete,
    navigation: './loansummary',
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.TRID,
    title: 'URLA',
    displayOrder: 2,
    icon: LoanItemStatusIconType.EmptyCircle,
    status: LoanItemStatus.NotComplete,
    navigation: './',
    exactMatch: true,
    action: () => {
      //
    },
    hasPopover: true,
  },
  {
    cardType: LoanStatusCardType.Credit,
    title: LoanStatusCardType.Credit,
    displayOrder: 3,
    icon: LoanItemStatusIconType.EmptyCircle,
    status: LoanItemStatus.NotComplete,
    navigation: 'credit',
    exactMatch: false,
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.Pricing,
    title: LoanStatusCardType.Pricing,
    displayOrder: 4,
    icon: LoanItemStatusIconType.UnLock,
    status: LoanItemStatus.NotComplete,
    navigation: 'clear1/pricelock',
    action: () => {
      //
    },
  },
  {
    isHidden: true, // Fees card should only show if flag is enabled. Remove this line when CCW2.0 feature flag is removed.
    cardType: LoanStatusCardType.Fees,
    title: LoanStatusCardType.Fees,
    displayOrder: 4,
    icon: LoanItemStatusIconType.None,
    status: LoanItemStatus.NotComplete,
    navigation: 'clear1/feeWorksheet',
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.AUS,
    title: 'DU / LPA',
    displayOrder: 5,
    descriptionHtml: 'Not Complete',
    navigation: 'aus',
    icon: LoanItemStatusIconType.None,
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.AUSHistory,
    title: LoanStatusCardType.AUSHistory,
    displayOrder: 6,
    descriptionHtml: '',
    icon: LoanItemStatusIconType.None,
    status: LoanItemStatus.NotComplete,
    navigation: 'aus-history',
    featureFlag: FeatureName.SandboxLoanMVP2,
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.Docs,
    title: LoanStatusCardType.Docs,
    displayOrder: 7,
    descriptionHtml: 'Not Complete',
    icon: LoanItemStatusIconType.None,
    navigation: 'documents/management',
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.Form4506C,
    title: LoanStatusCardType.Form4506C,
    displayOrder: 8,
    descriptionHtml: 'No Forms',
    icon: LoanItemStatusIconType.EmptyCircle,
    status: LoanItemStatus.NotComplete,
    navigation: './4506c',
    action: () => {
      //
    },
  },
  {
    cardType: LoanStatusCardType.Disclosures,
    title: LoanStatusCardType.Disclosures,
    displayOrder: 9,
    descriptionHtml: 'Not Complete',
    icon: LoanItemStatusIconType.None,
    status: LoanItemStatus.NotComplete,
    navigation: 'disclosures',
    featureFlag: FeatureName.Disclosures,
    action: () => {
      //
    },
  },
];
